import { http } from 'http';
import NProgressApp from 'utils/nprogress';

// Request interceptor Stratos API
http.interceptors.request.use(
  config => {
    const loading = config.loading !== undefined ? config.loading : true;
    if (loading) NProgressApp.start();
    config.headers['X-Api-Key'] = process.env.APP_BFF_API_KEY;
    config.headers['X-Client-Id'] = process.env.APP_BFF_CLIENT_ID;
    return config;
  },
  error => Promise.reject(error.data)
);

// Response interceptor Stratos API
http.interceptors.response.use(
  response => {
    const loading = response.config.loading !== undefined ? response.config.loading : true;
    if (loading) {
      NProgressApp.done();
    }
    return Promise.resolve(response);
  },
  error => {
    NProgressApp.done();
    // Do something with response error
    return Promise.reject(error);
  }
);
